import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

const HERO = "https://customer-assets.emergentagent.com/job_jungle-retreat-3/artifacts/94d2njbn_Hero.png";
// Portrait category-brand renders (natural aspect ~4:5) — crop cleanly in the tall side tiles
const IMG_L = "https://customer-assets-m6fa6gv7.emergentagent.net/job_jungle-retreat-3/artifacts/eo59m82s_Tarzan%20farmstay.png";
const IMG_R = "https://customer-assets-m6fa6gv7.emergentagent.net/job_jungle-retreat-3/artifacts/bi3opk9t_Tarzan%20Village.png";

const STORIES = [
  { title: "Plunge Pool",       img: "https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1000&q=80" },
  { title: "Fishing",           img: "https://images.pexels.com/photos/9315792/pexels-photo-9315792.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { title: "Cycling",           img: "https://images.unsplash.com/photo-1518107784960-eb57c673a7ba?auto=format&fit=crop&w=1000&q=80" },
  { title: "Yoga & Meditation", img: "https://images.pexels.com/photos/5864582/pexels-photo-5864582.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { title: "Sky Gazing",        img: "https://images.unsplash.com/photo-1519756719377-e084f8333a83?auto=format&fit=crop&w=1000&q=80" },
  { title: "Jungle Safari",     img: "https://images.pexels.com/photos/29187003/pexels-photo-29187003.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { title: "Trekking",          img: "https://images.pexels.com/photos/33742547/pexels-photo-33742547.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { title: "Kayaking",          img: "https://images.pexels.com/photos/1795508/pexels-photo-1795508.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { title: "Horse Riding",      img: "https://images.pexels.com/photos/33803734/pexels-photo-33803734.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { title: "Bonfire Nights",    img: "https://images.unsplash.com/photo-1596746698204-d69844da956d?auto=format&fit=crop&w=1000&q=80" },
  { title: "Farm To Table",     img: "https://images.unsplash.com/photo-1746702475474-fc4baed9f0c9?auto=format&fit=crop&w=1000&q=80" },
  { title: "Birdwatching",      img: "https://images.pexels.com/photos/29280658/pexels-photo-29280658.jpeg?auto=compress&cs=tinysrgb&w=1000" },
];

export default function Experiences() {
  return (
    <div className="bg-ivory">
      <section className="relative h-[52vh] min-h-[380px] w-full overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-forest-900/45 via-forest-900/40 to-forest-900/85" />
        <div className="relative container-tarzan h-full flex flex-col justify-end pb-14 text-ivory">
          <div className="eyebrow text-sand-200 mb-3">The Tarzan Experience</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight max-w-3xl">Experiences</h1>
          <p className="mt-4 text-ivory/85 max-w-xl leading-relaxed">Discover the rhythm of the wild — paddle, trek, meditate and gaze under a sky unspoiled by city lights.</p>
        </div>
      </section>

      <section className="py-24">
        <div className="container-tarzan grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="eyebrow mb-3">The Tarzan Experience</div>
            <h2 className="font-serif text-4xl md:text-5xl text-ink leading-[1.05] tracking-tight">Make Your Stay a<br/><em className="not-italic text-forest">Story Worth Telling.</em></h2>
            <div className="prose max-w-none mt-6 text-ink-soft text-base md:text-lg leading-relaxed space-y-4">
              <p>Choose your own adventure across India's wild frontiers — misty cliffs, hidden waterfalls, and forested valleys where calm meets thrill. Trek at sunrise, kayak through still waters, or drift along backwaters alive with birdsong. For the bold, soar over the hills by helicopter and touch down where coffee, canapés, and silence share the view.</p>
              <p>Every Tarzan retreat is a <em className="not-italic text-forest font-medium">story in motion</em> — designed for discovery, grounded in nature.</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 md:gap-5">
            <div className="rounded-[28px] overflow-hidden aspect-[4/5] mt-8"><img src={IMG_L} alt="" className="w-full h-full object-cover" /></div>
            <div className="rounded-[28px] overflow-hidden aspect-[4/5]"><img src={IMG_R} alt="" className="w-full h-full object-cover" /></div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-forest-50/60">
        <div className="container-tarzan">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <div className="eyebrow mb-3">Curated Adventures</div>
            <h2 className="font-serif text-4xl md:text-5xl text-ink tracking-tight">Stories waiting to be lived.</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {STORIES.map(s => (
              <Link key={s.title} to="/stays/tarzan-hyderabad-retreat" className="group relative aspect-[3/4] rounded-2xl overflow-hidden soft-shadow hover:luxe-shadow transition-all">
                <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-900/90 via-forest-900/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 flex items-end justify-between text-ivory">
                  <span className="font-serif text-lg md:text-xl">{s.title}</span>
                  <span className="h-9 w-9 rounded-full bg-ivory/15 backdrop-blur grid place-items-center group-hover:bg-ivory group-hover:text-forest-900 transition-colors"><ArrowRight className="h-4 w-4" /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="container-tarzan grid grid-cols-1 md:grid-cols-2 gap-10 items-end">
          <div>
            <div className="eyebrow mb-3">Stories From the Wild</div>
            <h2 className="font-serif text-4xl md:text-5xl text-ink tracking-tight">Field notes, guides and slow-travel journals.</h2>
            <p className="text-ink-soft mt-4 leading-relaxed max-w-md">Our journal brings these moments to life — hidden valleys, quiet cliffs and reflections on design, silence and sustainability.</p>
            <Link to="/gallery" className="inline-flex items-center gap-2 mt-6 text-forest text-sm tracking-[0.18em] uppercase font-semibold hover:gap-3 transition-all">See the gallery <ArrowUpRight className="h-4 w-4" /></Link>
          </div>
          <div className="rounded-3xl overflow-hidden aspect-[16/9]"><img src="https://customer-assets.emergentagent.com/job_jungle-retreat-3/artifacts/94d2njbn_Hero.png" alt="" className="w-full h-full object-cover" /></div>
        </div>
      </section>
    </div>
  );
}
